import { ActivityFeedsPropData } from "../../../types/DispatchExplorer"

export const TimeActivityFeed = ({ data }: { data: ActivityFeedsPropData }) => {
  return <strong>{String(data.value)}</strong>
}
